(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craftmag-daily-products"] && !Shopify.designMode) return;
  try {
    
function craftmagDaily(root) {
  const cards = Array.from(root.querySelectorAll('.resource-list__item'));
  if (!cards.length) return;
  function refresh() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(p => [p.type, p.value]));
    const day = Math.floor(Date.UTC(Number(values.year), Number(values.month)-1, Number(values.day))/86400000);
    if (root.dataset.dailyDate === String(day)) return;
    const count = Math.min(Number(root.dataset.craftmagDaily), cards.length);
    const start = (day * count) % cards.length;
    cards.forEach((card, index) => { const rank = (index-start+cards.length)%cards.length; card.hidden = rank >= count; card.style.order = String(rank); });
    root.dataset.dailyDate = String(day);
    root.dataset.dailyReady = 'true';
  }
  refresh();
  const timer = setInterval(() => { if (!root.isConnected) clearInterval(timer); else refresh(); }, 60000);
}
document.querySelectorAll('[data-craftmag-daily]').forEach(craftmagDaily);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-craftmag-daily]').forEach(craftmagDaily));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
